// src/pages/financeiro/FormaPagCad.js
import React, { useState, useEffect } from 'react';

import Input from '../../components/input/Input.js';
import FormaPag, { getDescricaoMeioPagamento, MeioPagamento } from '../../models/financeiro/FormaPag.js'; // Corrigir a importação do model FormaPag
import { useFormaPag } from '../../contexts/financeiro/FormaPagContext.js';
import FormaPagSearch from './FormaPagSearch'; // Import FormaPagSearch
import InputCheck from '../../components/input/InputCheck.js'; // Import InputCheck
import Select from '../../components/input/Select.js';

import ContaBancoSearch from './ContaBancoSearch.js';
import { ContaBanco } from '../../models/financeiro/ContaBanco.ts';
import { useContaBanco } from '../../contexts/financeiro/ContaBancoContext.js';
import { useMessage } from '../../contexts/geral/MessageContext.js';
import { useYesNo } from '../../contexts/geral/YesNoContext.js';

import { useConfigModulo } from '../../contexts/administrativo/ConfigModuloContext.js';
import { normalizeDecimalInputBr, formatNumeric, parseNumeric } from '../../utils/numberUtils.js';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalTabs from '../../components/modalForm/ModalTabs';
import ModalActions, { ModalActionButton } from '../../components/modalForm/ModalActions';

const FormaPagCad = ({ show, onHide, formaPag: initialFormaPag }) => {
    const { configModuloSel } = useConfigModulo();
    const { formasPag, addFormaPag, updateFormaPag, deleteFormaPag } = useFormaPag();
    const [formaPag, setFormaPag] = useState(initialFormaPag || new FormaPag());
    const [showSearchModal, setShowSearchModal] = useState(false);
    const {showMessage} = useMessage();
    const { showYesNo } = useYesNo();
    const [novoReg, setNovoReg] = useState(false);  

    const [showSearchModalBanco, setShowSearchModalBanco] = useState(false);    
    const { contasBanco } = useContaBanco();

    const [activeTab, setActiveTab] = useState('Recebimento');

    useEffect(() => {
        if (!initialFormaPag) {
            setFormaPag(new FormaPag());
        }
    }, [initialFormaPag]);

    useEffect(() => {
        if (!configModuloSel?.moduloPedido && activeTab === 'Delivery') setActiveTab('Recebimento');
    }, [configModuloSel?.moduloPedido, activeTab]);

    const handleNovo = () => {
        setFormaPag(new FormaPag());
        setNovoReg(true);        
    };

    const handleEditar = (id) => {
        if (id === 0) {
            showMessage("Selecione uma forma de pagamento para editar!");            
            return;
        }            
        setNovoReg(false);
    };

    const handleDelete = async () => {
        if (!formaPag?.id) {
            showMessage("Selecione uma forma de pagamento para excluir!");            
        } else {
            const resposta = await showYesNo("Deseja excluir a forma de pagamento selecionada?");
            if (resposta) {
                await deleteFormaPag(formaPag.id);
                handleNovo();
            }
        }
    };

    const handleSave = async () => {
        try {
            if (!formaPag.descricao) {
                showMessage("Descrição não preenchida!");                
                return;
            }

            const descontoDelivery = parseNumeric(formaPag.descontoDelivery);
            if (descontoDelivery < 0 || descontoDelivery > 100) {
                showMessage('O desconto no Delivery deve estar entre 0 e 100%.');
                return;
            }
            const dados = { ...formaPag, descontoDelivery };
            if (!formaPag.id) {
                await addFormaPag(dados);
            } else {
                await updateFormaPag(dados);
            }
            handleNovo();
        } catch (error) {
            console.error("Erro ao gravar dados: ", error);
        }
    };

    const handleExit = () => {
        const formaPagSelecionada = formasPag.find(f => f.id.toString() === formaPag?.id?.toString());

        if (formaPagSelecionada) {
            setFormaPag(formaPagSelecionada);
            handleEditar(formaPag?.id);
        } else {
            setFormaPag(new FormaPag());
        }
    };

    const handleExitBanco = () => {
        const bancoSelecionado = contasBanco.find(f => f.id.toString() === formaPag?.contaBancoId?.toString());    
        if (bancoSelecionado) {            
            setFormaPag({ ...formaPag, contaBanco: bancoSelecionado });           
            //handleEditar(formaPag?.id);
        } else {            
            setFormaPag({ ...formaPag, contaBanco: new ContaBanco() });
        }
    };

    const handleSelectFormaPag = (formaPagSel) => {
        setFormaPag(formaPagSel);
        setShowSearchModal(false);
        if (formaPagSel) {            
            handleEditar(formaPagSel.id);
        } else {
            setFormaPag(new FormaPag());
        }
    };

    const handleTabChange = (tab) => (e) => {
        e.preventDefault(); // Previne o refresh ao clicar nas tabs
        setActiveTab(tab);
    };

    const handleSelectContaBanco = (contaBancoSel) => {            
            setShowSearchModalBanco(false);
            if (contaBancoSel) {            
                setFormaPag({ ...formaPag, contaBancoId: contaBancoSel.id, contaBanco:contaBancoSel });
            } else {
                setFormaPag({ ...formaPag, contaBancoId: null, contaBanco: new ContaBanco() });                
            }
        };

    const handleMeioPagamentoChange = (event) => {
        const meioPag = Number(event.target.value);

        setFormaPag({
            ...formaPag,
            meioPag,
            // TEF Manual não utiliza a integração automática com o terminal.
            usaTef: meioPag === MeioPagamento.TEF_Manual ? false : formaPag.usaTef
        });
    };

    if (!show) return null;

    return (
        <ModalContainer show={show} largura="600px" variant="cadastro" onHide={onHide}>

            <ModalHeader title={novoReg ? 'Nova Forma de Pagamento' : 'Alterar Forma de Pagamento' } onHide={onHide} />
            <ModalBody className="modal-body">
                <form>
                    <div className="input-group mb-3">
                        <Input
                            label="Código"
                            value={formaPag.id || ''}
                            onChange={(e) => setFormaPag({ ...formaPag, id: e.target.value })}
                            onBlur={handleExit}
                            disabled={!novoReg}
                            btnBuscar={() => setShowSearchModal(true)}
                        />
                        <Input
                            label="Descrição"
                            value={formaPag.descricao || ''}
                            onChange={(e) => setFormaPag({ ...formaPag, descricao: e.target.value })}
                            size={300}
                            autoFocus={true}
                        />
                        <InputCheck
                            id="inativo"
                            label="Inativo"
                            checked={formaPag.inativo}
                            onChange={(e) => setFormaPag({ ...formaPag, inativo: e.target.checked })}

                        />
                    </div>

                    {/* Menu de Tabs */}
                    <ModalTabs >
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'Recebimento' ? 'active' : ''}`}
                                onClick={handleTabChange('Recebimento')}
                            >
                                Recebimento
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'Caixa' ? 'active' : ''}`}
                                onClick={handleTabChange('Caixa')}
                            >
                                Caixa
                            </button>
                        </li>
                        {configModuloSel?.moduloPedido && (
                            <li className="nav-item">
                                <button type="button" className={`nav-link ${activeTab === 'Delivery' ? 'active' : ''}`} onClick={handleTabChange('Delivery')}>
                                    Delivery
                                </button>
                            </li>
                        )}
                    </ModalTabs>

                    {activeTab === 'Recebimento' && (
                        <div>
                            <div className="input-group">
                                <Select
                                    label="Meio de Pagamento"
                                    value={formaPag.meioPag}
                                    size={170}
                                    onChange={handleMeioPagamentoChange}
                                    options={Object.values(MeioPagamento)
                                        .filter((value) => !isNaN(Number(value))) // Filtra apenas os valores numéricos
                                        .map((value) => ({
                                            value: value,
                                            label: getDescricaoMeioPagamento(value), // Obtém a descrição do meio de pagamento
                                        }))}
                                    style={{marginRight: '20px'}}
                                />

                                <InputCheck
                                    id="avista"
                                    label="Á vista"
                                    checked={formaPag.avista}
                                    onChange={(e) => setFormaPag({ ...formaPag, avista: e.target.checked })}
                                />
                                <InputCheck
                                    id="recebimentoAut"
                                    label="Recebimento Aut."
                                    checked={formaPag.recebimentoAut}
                                    onChange={(e) => setFormaPag({ ...formaPag, recebimentoAut: e.target.checked })}
                                />

                                <InputCheck
                                    id="usaTef"
                                    label="Usa TEF"
                                    checked={formaPag.usaTef === true}
                                    onChange={(e) => setFormaPag({ ...formaPag, usaTef: e.target.checked })}
                                />

                            </div>
                            <div className="input-group">

                                <Input
                                    label="Conta Bancária"
                                    value={formaPag.contaBancoId || ''}
                                    onChange={(e) => setFormaPag({ ...formaPag, contaBancoId: e.target.value })}
                                    onBlur={handleExitBanco}
                                    btnBuscar={() => setShowSearchModalBanco(true)}
                                />
                                <Input
                                    value={formaPag.contaBancoDescricao || formaPag.contaBanco?.descricaoConta || ''}
                                    //onChange={(e) => setFormaPag({ ...formaPag, descricao: e.target.value })}
                                    size={300}
                                    autoFocus={true}
                                    disabled
                                />
                            </div>

                            <div className="input-group">
                                <Input
                                    label="Desconto"
                                    value={formaPag.desconto || ''}
                                    onChange={(e) => setFormaPag({ ...formaPag, desconto: e.target.value })}
                                    //onBlur={handleExit}
                                    //disabled={disableCampos}
                                    //type="number"
                                    size={80}
                                />

                                <Select
                                    label="Qtde Parcelas"
                                    value={parseInt(formaPag.qtdeParcela)}
                                    //onChange={(e) => e.target.value}
                                    onChange={(e) => setFormaPag({ ...formaPag, qtdeParcela: e.target.value })}

                                    options={[
                                        { value: 1, label: '1x' },
                                        { value: 2, label: '2x' },
                                        { value: 3, label: '3x' },
                                        { value: 5, label: '5x' },
                                        { value: 6, label: '6x' },
                                        { value: 10, label: '10x' },
                                        { value: 12, label: '12x' },
                                    ]}
                                    size={100}
                                />

                                <Input
                                    label="Dia Venc."
                                    value={formaPag.diaVencimento || ''}
                                    onChange={(e) => setFormaPag({ ...formaPag, diaVencimento: e.target.value })}
                                    size={80}
                                />

                            </div>

                            <div className="input-group">
                                <Input
                                    label="Juro Mensal"
                                    value={formaPag.juroMensal || ''}
                                    onChange={(e) => setFormaPag({ ...formaPag, juroMensal: e.target.value })}
                                    size={80}
                                />
                                <Input
                                    label="Juro Atraso Dia"
                                    value={formaPag.juroAtrasoDia || ''}
                                    onChange={(e) => setFormaPag({ ...formaPag, juroAtrasoDia: e.target.value })}
                                    size={80}
                                />
                            </div>
                        </div>
                    )}
                    {configModuloSel?.moduloPedido && activeTab === 'Delivery' && (
                        <div>
                            <Input label="Desconto no Delivery (%)" type="text"
                                value={formaPag.descontoDelivery ?? 0}
                                onChange={(e) => setFormaPag({ ...formaPag, descontoDelivery: normalizeDecimalInputBr(e.target.value) })}
                                onBlur={() => setFormaPag({ ...formaPag, descontoDelivery: formatNumeric(formaPag.descontoDelivery) })}
                                style={{ textAlign: 'right' }} size={180} />
                            <p>Percentual sobre os itens em entrega e retirada, somado ao desconto geral do app. A taxa de entrega não recebe desconto. Informe zero para não oferecer este benefício.</p>
                        </div>
                    )}
                    {activeTab === 'Caixa' && (
                        <div>
                            {/* Adicione inputs específicos para a aba Caixa aqui */}
                            <div className="input-group">
                                <InputCheck
                                    id="caixaMov"
                                    label="Movimenta Caixa"
                                    checked={formaPag.caixaMov}
                                    onChange={(e) => setFormaPag({ ...formaPag, caixaMov: e.target.checked })}
                                />
                                <InputCheck
                                    id="caixaLocal"
                                    label="Caixa Local"
                                    checked={formaPag.caixaLocal}
                                    onChange={(e) => setFormaPag({ ...formaPag, caixaLocal: e.target.checked })}
                                />
                                <InputCheck
                                    id="caixaResumoRel"
                                    label="Resumo Caixa"
                                    checked={formaPag.caixaResumoRel}
                                    onChange={(e) => setFormaPag({ ...formaPag, caixaResumoRel: e.target.checked })}
                                />
                            </div>
                        </div>
                    )}
                </form>
            </ModalBody>
            <ModalFooter className="modal-footer justify-content-end">
                <ModalActions >
                    <ModalActionButton className="btn btn-primary" onClick={handleSave} action="save">
                        Salvar
                    </ModalActionButton>
                    <ModalActionButton className="btn btn-danger" onClick={handleDelete} disabled={novoReg} action="delete">
                        Excluir
                    </ModalActionButton>
                    <ModalActionButton className="btn btn-secondary" onClick={handleNovo} disabled={novoReg} action="new">
                        Novo
                    </ModalActionButton>
                </ModalActions>
            </ModalFooter>

            <FormaPagSearch
                show={showSearchModal}
                onHide={() => setShowSearchModal(false)}
                onSelectFormaPag={handleSelectFormaPag}
            />

            <ContaBancoSearch
                show={showSearchModalBanco}
                onHide={() => setShowSearchModalBanco(false)}
                onSelectContaBanco={handleSelectContaBanco}
            />

        </ModalContainer>
    );
};

export default FormaPagCad;
